
import React from "react";
import { Formik, Form, Field } from "formik";
import { useParams} from "react-router-dom";
import { ProductSchema } from "./ProductSchema";
import { useProductById } from "./hooks/useProductById";
import BlockUi from "react-block-ui";



export function ProductById() {
  const { id } = useParams();

  const { product, handleSubmit } = useProductById(id);

  if (!product) {
    return (
		<div className="col-xl-12">
			<BlockUi blocking={!product}></BlockUi>
		</div>
		)
  }

  return (
    <>
      <h1 className="azul-cabecalho">Editar Produto</h1>
      <p className="subheader-text mb-10">
        Edite as informações do produto
      </p>
      <div className="row mb-10">
        <div className="col-xl-12">
          <div
            style={{
              backgroundColor: "var(--bg-neutral-layer01)",
              border: "1px solid var(--border-neutral-subtle)",
              borderRadius: "5px",
              padding: "20px",
            }}
          >
            <Formik
              initialValues={{
                name: product.name,
                description: product.description,
                dashboard_description: product.dashboardDescription,
								identification: product.identification,
								price: product.price,
								universalPrice: product.universalPrice,
						
              }}
              validationSchema={ProductSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched, values, handleChange }) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="name">Nome</label>
                    <Field
                      name="name"
                      className="form-control"
                      id="name"
                      value={values.name}
                      onChange={handleChange}
                    />
                    {errors.name && touched.name ? (
                      <div className="text-danger">{errors.name}</div>
                    ) : null}
                  </div>
                  <div className="form-group">
                    <label htmlFor="description">Descrição</label>
                    <Field
                      name="description"
                      as="textarea"
                      className="form-control"
                      id="description"
                      value={values.description}
                      onChange={handleChange}
                    />
                    {errors.description && touched.description ? (
                      <div className="text-danger">{errors.description}</div>
                    ) : null}
                  </div>
                  <div className="form-group">
                    <label htmlFor="dashboard_description">
                      Descrição do Dashboard
                    </label>
                    <Field
                      name="dashboard_description"
                      as="textarea"
                      className="form-control"
                      id="dashboard_description"
                      value={values.dashboard_description}
                      onChange={handleChange}
                    />
                    {errors.dashboard_description && touched.dashboard_description ? (
                      <div className="text-danger">
                        {errors.dashboard_description}
                      </div>
                    ) : null}
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Atualizar Produto
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
